
export function IsMobile() {
  return window.innerWidth < 992 ? true : false;
}
